import { Component, type ReactNode } from 'react';

interface State {
  error: Error | null;
}

// Root-level safety net: any uncaught render error shows a friendly recovery screen
// instead of unmounting the whole app to a blank white page.
export class ErrorBoundary extends Component<{ children: ReactNode }, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: unknown) {
    // Surface the exact error to the console so it can be diagnosed.
    console.error('[ErrorBoundary] Render crashed:', error, info);
  }

  render() {
    if (this.state.error) {
      return (
        <div style={{ minHeight: '100vh', display: 'grid', placeItems: 'center', background: '#0b0f0d', color: '#e6ece9', padding: 24, fontFamily: 'system-ui, sans-serif' }}>
          <div style={{ maxWidth: 460, textAlign: 'center' }}>
            <div style={{ fontSize: 44 }}>⚽</div>
            <h1 style={{ fontSize: 20, fontWeight: 800, margin: '12px 0 6px' }}>Something went wrong</h1>
            <p style={{ fontSize: 13, color: '#9aa9a3', lineHeight: 1.6 }}>
              A section failed to render. Your data is safe — try reloading.
            </p>
            <button
              onClick={() => { this.setState({ error: null }); window.location.reload(); }}
              style={{ marginTop: 18, padding: '12px 28px', borderRadius: 12, background: '#10b981', color: '#04120c', fontWeight: 800, border: 0, cursor: 'pointer', fontSize: 14 }}
            >
              Reload app
            </button>
            <p style={{ fontSize: 11, color: '#5f6c66', marginTop: 16 }}>
              {String(this.state.error.message || this.state.error)}
            </p>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}